import { createContext, useReducer } from 'react';
import { Kroger, Heb, Ralphs, Amazon } from '../../assets/images';

export const Context = createContext();

const Store = ({ children }) => {
    const [state, dispatch] = useReducer(
        (state, action) => {
            return { ...state, ...action };
        },
        {
            selectedTab: '',
            mainNavIsOpen: false,
            productsNavIsOpen: false,
            modalSearchIsOpen: false,
            modalWhereToBuyIsOpen: false,
            storesModalProducts: {
                'original-recipe-refried-beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B0BBSHBB9L?th=1',
                        alt: 'Amazon',
                    },
                    {
                        img: Kroger,
                        link: 'https://www.kroger.com/p/isadora-original-refried-beans/0078162400805?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Kroger',
                    },
                    {
                        img: Heb,
                        link: 'https://www.heb.com/product-detail/isadora-original-refried-beans-15-2-oz/1533976',
                        alt: 'Heb',
                    },
                    {
                        img: Ralphs,
                        link: 'https://www.ralphs.com/p/isadora-original-refried-beans/0078162400805?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Ralphs',
                    },
                ],
                'mayocoba-refried-beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B0793PM46J',
                        alt: 'Amazon',
                    },
                    {
                        img: Kroger,
                        link: 'https://www.kroger.com/p/isadora-mayocoba-peruano-refried-beans/0078162400844?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Kroger',
                    },
                    {
                        img: Ralphs,
                        link: 'https://www.ralphs.com/p/isadora-mayocoba-peruano-refried-beans/0078162400844?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Ralphs',
                    },
                ],
                'Black-Refried-beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B0BBSHHD9B?th=1',
                        alt: 'Amazon',
                    },
                    {
                        img: Kroger,
                        link: 'https://www.kroger.com/p/isadora-black-refried-beans/0078162400786?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Kroger',
                    },
                    {
                        img: Ralphs,
                        link: 'https://www.ralphs.com/p/isadora-black-refried-beans/0078162400786?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Ralphs',
                    },
                ],
                'Low-Fat-Refried-Beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B00FD9J5OU?th=1',
                        alt: 'Amazon',
                    },
                    {
                        img: Heb,
                        link: 'https://www.heb.com/product-detail/isadora-low-fat-refried-beans-15-2-oz/1533975',
                        alt: 'Heb USA',
                    },
                ],
                'Fat-Free-Refried-Beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B00FD9J5OU?th=1',
                        alt: 'Amazon',
                    },
                    {
                        img: Heb,
                        link: 'https://www.heb.com/product-detail/isadora-low-fat-refried-beans-15-2-oz/1533975',
                        alt: 'Heb USA',
                    },
                ],
                'Traditional-Refried-Beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B00FD9J5R2?th=1',
                        alt: 'Amazon',
                    },
                    {
                        img: Kroger,
                        link: 'https://www.kroger.com/p/isadora-traditional-refried-beans/0078162400787?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Kroger',
                    },
                    {
                        img: Heb,
                        link: 'https://www.heb.com/product-detail/isadora-traditional-refried-beans-15-2-oz/1533978',
                        alt: 'Heb USA',
                    },
                    {
                        img: Ralphs,
                        link: 'https://www.ralphs.com/p/isadora-traditional-refried-beans/0078162400787?fulfillment=PICKUP&searchType=default_search',
                        alt: 'Ralphs',
                    },
                ],
                'Whole-Black-Beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B0BM59RZM9?th=1',
                        alt: 'Amazon',
                    },
                ],
                'Whole-Mayocoba-Beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B0BM585WRP?th=1',
                        alt: 'Amazon',
                    },
                ],
                'Whole-Pinto-Beans': [
                    {
                        img: Amazon,
                        link: 'https://www.amazon.com/dp/B0BM59WNF8?th=1',
                        alt: 'Amazon',
                    },
                ],
            },
        }
    );
    return (
        <Context.Provider value={{ state, dispatch }}>
            {children}
        </Context.Provider>
    );
};

export default Store;
